import { useAuth } from '../../../lib/auth';
import AuthLayout from '../../layouts/AuthLayout';
import clsx from 'clsx';
import { Button } from '../../../components/buttons/Button.tsx';
import { Link } from 'react-router';
import { cn } from '../../../lib/helpers.ts';
import {
    UilCheck,
    UilFileAlt,
    UilKeySkeletonAlt,
} from '@iconscout/react-unicons';

export default function SelectLicensePage() {
    const { user, userHasFullLicense } = useAuth({
        middleware: 'auth',
        redirectTo: '/',
        tmp: 'SelectLicensePage',
    });

    const isContactPerson = user?.is_institution_contact_person;

    // Only for contact person
    // const navigate = useNavigate();
    // if (!user?.is_institution_contact_person) {
    //     navigate('/');
    // }

    return (
        <AuthLayout>
            <main
                className={clsx(
                    'relative',
                    'mx-auto box-content py-9',
                    'max-w-2xl xl:max-w-6xl',
                    'px-4 sm:px-8 md:px-10'
                )}
            >
                <div className="mb-14">
                    <h1>Vyberte si způsob aktivace</h1>
                    <p className="text-lg text-ink-800">
                        Můžete si aplikaci nejdříve vyzkoušet zdarma nebo rovnou
                        zakoupit plnou verzi
                    </p>
                </div>
                <div>
                    <div
                        className={cn(
                            'mt-12 w-full gap-12 pb-32',
                            'max-w-3xl grid-cols-1 xl:max-w-none xl:grid-cols-2',
                            'xl:grid-cols-[1fr_420px]'
                        )}
                    >
                        <div className="mb-12 grid gap-8 md:grid-cols-2">
                            <div className="relative flex flex-col rounded-2xl border-2 border-transparent bg-white p-8 shadow-sm hover:border-turquoise-500/40">
                                <div className="absolute right-4 top-4">
                                    <div className="focus:ring-ring inline-flex items-center rounded-full border-0 border-transparent bg-turquoise-100 px-3 py-1 text-sm font-semibold text-turquoise-600 transition-colors hover:bg-turquoise-100 focus:outline-none focus:ring-2 focus:ring-offset-2">
                                        Zdarma
                                    </div>
                                </div>
                                <div className="flex grow flex-col space-y-1.5 pb-6">
                                    <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-turquoise-100">
                                        <UilKeySkeletonAlt
                                            size={40}
                                            className="text-turquoise-600"
                                        />
                                    </div>
                                    <h3 className="font-heading mb-3 text-[28px] font-bold leading-9 tracking-[0.4px] text-ink-900">
                                        Vyzkoušejte plnou verzi zdarma
                                    </h3>
                                    <p className="text-base leading-6 tracking-[0.05px] text-ink-800">
                                        Získejte přístup ke všem cvičením,
                                        kategoriím a funkcím bez omezení.
                                        Zkušební verze trvá 14 dní a platí pro
                                        celou školu. Nevyžaduje zadání
                                        platebních údajů. Po uplynutí se
                                        aplikace přepne zpět do demoverze.
                                    </p>
                                </div>
                                {user?.institution.demo_requested_at ? (
                                    <Button
                                        disabled
                                        color="turquoise"
                                        className="mb-6 w-full bg-turquoise-500/50"
                                    >
                                        Zkušební verze již byla využita
                                    </Button>
                                ) : (
                                    <Link to="/koupit/zkusebni-verze">
                                        <Button
                                            color="turquoise"
                                            className="mb-6 w-full"
                                        >
                                            Aktivovat 14denní zkušební verzi
                                        </Button>
                                    </Link>
                                )}
                                <div className="space-y-3">
                                    <p className="mb-2 text-sm font-semibold text-ink-900">
                                        Co získáte:
                                    </p>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            100+ cvičení na celý rok
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            Pravidelné doplňování nového obsahu
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            Metodika pro učitele
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            Technická podpora
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="relative flex flex-col rounded-2xl border-2 border-transparent bg-white p-8 shadow-sm hover:border-product-200">
                                <div className="absolute right-4 top-4">
                                    <div className="focus:ring-ring inline-flex items-center rounded-full border-0 border-transparent bg-product-100 px-3 py-1 text-sm font-semibold text-product-500 transition-colors hover:bg-product-100 focus:outline-none focus:ring-2 focus:ring-offset-2">
                                        Pro školy
                                    </div>
                                </div>
                                <div className="flex grow flex-col space-y-1.5 pb-6">
                                    <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-product-100">
                                        <UilFileAlt
                                            size={40}
                                            className="text-product-500"
                                        />
                                    </div>
                                    <h3 className="font-heading mb-3 text-[28px] font-bold leading-9 tracking-[0.4px] text-ink-900">
                                        Zakoupit plnou verzi
                                    </h3>
                                    <p className="text-base leading-6 tracking-[0.05px] text-ink-800">
                                        Objednejte si roční nebo měsíční licenci
                                        pro vaši školu. Faktura bude zaslána
                                        e-mailem po zpracování objednávky.
                                    </p>
                                </div>
                                {isContactPerson ? (
                                    <Link to="/koupit/plna-verze">
                                        <Button
                                            color="product"
                                            className="mb-6 w-full"
                                        >
                                            Přejít na objednávku
                                        </Button>
                                    </Link>
                                ) : (
                                    <Button
                                        disabled
                                        color="product"
                                        className="mb-6 w-full bg-product-500/50"
                                    >
                                        Požádejte vaši kontaktní osobu o
                                        aktivaci
                                    </Button>
                                )}
                                <div className="space-y-3">
                                    <p className="mb-2 text-sm font-semibold text-ink-900">
                                        Co získáte:
                                    </p>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            100+ cvičení na celý rok
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            Pravidelné doplňování nového obsahu
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            Metodika pro učitele
                                        </span>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-turquoise-500">
                                            <UilCheck
                                                size={16}
                                                className="text-white"
                                            />
                                        </div>
                                        <span className="text-sm leading-5 tracking-[0.05px] text-ink-900">
                                            Technická podpora
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </AuthLayout>
    );
}
